// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b5479536","453":"8add67d4","732":"2d20f43f"}[chunkId] + ".chunk.js";
};